<template>
  <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12.5" cy="12.5" r="9" stroke="currentColor" />
    <path d="M8 13.7273L11.2318 17L17 8" stroke="currentColor" />
  </svg>
</template>
